var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalShown,
          expression: "modalShown"
        },
        {
          name: "drag",
          rawName: "v-drag",
          value: { handle: "#modal-moving" },
          expression: "{handle:'#modal-moving'}"
        }
      ],
      staticClass: "modal",
      staticStyle: { position: "fixed" },
      attrs: { id: "nesting-config-modal" }
    },
    [
      _c("div", { staticClass: "modal-main" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "data-area" }, [
          _c("div", { staticClass: "error_message" }, [
            _vm._v(_vm._s(_vm.errorMessage.text))
          ]),
          _vm._v(" "),
          _c("ul", [
            _vm._m(1),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [
                _vm._v("ネスティングパターン選択")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.nestMode,
                          expression: "nestMode",
                          modifiers: { number: true }
                        }
                      ],
                      attrs: { type: "radio", value: "2" },
                      domProps: { checked: _vm._q(_vm.nestMode, _vm._n("2")) },
                      on: {
                        change: function($event) {
                          _vm.nestMode = _vm._n("2")
                        }
                      }
                    }),
                    _vm._v("コスト優先")
                  ])
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.nestMode,
                          expression: "nestMode",
                          modifiers: { number: true }
                        }
                      ],
                      attrs: { type: "radio", value: "0" },
                      domProps: { checked: _vm._q(_vm.nestMode, _vm._n("0")) },
                      on: {
                        change: function($event) {
                          _vm.nestMode = _vm._n("0")
                        }
                      }
                    }),
                    _vm._v("歩留まり優先")
                  ])
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.nestMode,
                          expression: "nestMode",
                          modifiers: { number: true }
                        }
                      ],
                      attrs: { type: "radio", value: "1" },
                      domProps: { checked: _vm._q(_vm.nestMode, _vm._n("1")) },
                      on: {
                        change: function($event) {
                          _vm.nestMode = _vm._n("1")
                        }
                      }
                    }),
                    _vm._v("加工時間優先")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [_vm._v("カット回数")]),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.nestZCutFlag,
                          expression: "nestZCutFlag",
                          modifiers: { number: true }
                        }
                      ],
                      attrs: { type: "radio", value: "0" },
                      domProps: {
                        checked: _vm._q(_vm.nestZCutFlag, _vm._n("0"))
                      },
                      on: {
                        change: function($event) {
                          _vm.nestZCutFlag = _vm._n("0")
                        }
                      }
                    }),
                    _vm._v("２回")
                  ])
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.nestZCutFlag,
                          expression: "nestZCutFlag",
                          modifiers: { number: true }
                        }
                      ],
                      attrs: { type: "radio", value: "1" },
                      domProps: {
                        checked: _vm._q(_vm.nestZCutFlag, _vm._n("1"))
                      },
                      on: {
                        change: function($event) {
                          _vm.nestZCutFlag = _vm._n("1")
                        }
                      }
                    }),
                    _vm._v("３回")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [_vm._v("カット最小寸法")]),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", { staticClass: "detail-label" }, [_vm._v("幅")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nestCutMinW,
                      expression: "nestCutMinW"
                    }
                  ],
                  attrs: { type: "number" },
                  domProps: { value: _vm.nestCutMinW },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nestCutMinW = $event.target.value
                    }
                  }
                }),
                _vm._v("㎜\n            "),
                _c("span", { staticClass: "detail-label" }, [_vm._v("高さ")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nestCutMinH,
                      expression: "nestCutMinH"
                    }
                  ],
                  attrs: { type: "number" },
                  domProps: { value: _vm.nestCutMinH },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nestCutMinH = $event.target.value
                    }
                  }
                }),
                _vm._v("㎜\n          ")
              ])
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label radio-label" }, [
                _vm._v("カット機条件")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("div", { staticClass: "input-detail" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.nestStackFlag,
                          expression: "nestStackFlag",
                          modifiers: { number: true }
                        }
                      ],
                      attrs: { type: "radio", value: "1" },
                      domProps: {
                        checked: _vm._q(_vm.nestStackFlag, _vm._n("1"))
                      },
                      on: {
                        change: function($event) {
                          _vm.nestStackFlag = _vm._n("1")
                        }
                      }
                    }),
                    _vm._v(
                      "\n                リップカットとクロスカットが同じ機械\n              "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-detail" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.nestStackFlag,
                          expression: "nestStackFlag",
                          modifiers: { number: true }
                        }
                      ],
                      attrs: { type: "radio", value: "0" },
                      domProps: {
                        checked: _vm._q(_vm.nestStackFlag, _vm._n("0"))
                      },
                      on: {
                        change: function($event) {
                          _vm.nestStackFlag = _vm._n("0")
                        }
                      }
                    }),
                    _vm._v(
                      "\n                リップカットとクロスカットが別の機械\n              "
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [_vm._v("刃物厚さ")]),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nestSawW,
                      expression: "nestSawW"
                    }
                  ],
                  attrs: { type: "number" },
                  domProps: { value: _vm.nestSawW },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nestSawW = $event.target.value
                    }
                  }
                }),
                _vm._v("㎜\n          ")
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [
                _vm._v("ランニングソー 逃げ爪量")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nestNigetsume,
                      expression: "nestNigetsume"
                    }
                  ],
                  attrs: { type: "number" },
                  domProps: { value: _vm.nestNigetsume },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nestNigetsume = $event.target.value
                    }
                  }
                }),
                _vm._v("㎜\n          ")
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "space-li" }, [
              _c("div", { staticClass: "space-form" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nestConfSpaceUp,
                      expression: "nestConfSpaceUp"
                    }
                  ],
                  attrs: { type: "number" },
                  domProps: { value: _vm.nestConfSpaceUp },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nestConfSpaceUp = $event.target.value
                    }
                  }
                }),
                _vm._v("㎜\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "space-form middle" }, [
                _c("div", { staticClass: "side" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.nestConfSpaceLt,
                        expression: "nestConfSpaceLt"
                      }
                    ],
                    attrs: { type: "number" },
                    domProps: { value: _vm.nestConfSpaceLt },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.nestConfSpaceLt = $event.target.value
                      }
                    }
                  }),
                  _vm._v("㎜\n          ")
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("svg", { attrs: { width: "200", height: "150" } }, [
                    _c("rect", {
                      attrs: {
                        x: "0",
                        y: "0",
                        width: "200",
                        height: "150",
                        stroke: "lightgray",
                        fill: "lightgray"
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "side" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.nestConfSpaceRt,
                        expression: "nestConfSpaceRt"
                      }
                    ],
                    attrs: { type: "number" },
                    domProps: { value: _vm.nestConfSpaceRt },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.nestConfSpaceRt = $event.target.value
                      }
                    }
                  }),
                  _vm._v("㎜\n          ")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "space-form" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nestConfSpaceLo,
                      expression: "nestConfSpaceLo"
                    }
                  ],
                  attrs: { type: "number" },
                  domProps: { value: _vm.nestConfSpaceLo },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nestConfSpaceLo = $event.target.value
                    }
                  }
                }),
                _vm._v("㎜\n        ")
              ])
            ]),
            _c("li", [
              _c("span", { staticClass: "label" }, [_vm._v("加工タクト")]),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", [_vm._v("刃物送り速度")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nestCutlengthSec,
                      expression: "nestCutlengthSec"
                    }
                  ],
                  attrs: { type: "number" },
                  domProps: { value: _vm.nestCutlengthSec },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nestCutlengthSec = $event.target.value
                    }
                  }
                }),
                _vm._v("秒/M\n          ")
              ])
            ]),
            _c("li", [
              _c("span", { staticClass: "label" }),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", [_vm._v("刃物昇降")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nestCutcutSec,
                      expression: "nestCutcutSec"
                    }
                  ],
                  attrs: { type: "number" },
                  domProps: { value: _vm.nestCutcutSec },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nestCutcutSec = $event.target.value
                    }
                  }
                }),
                _vm._v("秒/1カット\n          ")
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", [_vm._v("板セット")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nestCutSetSec,
                      expression: "nestCutSetSec"
                    }
                  ],
                  attrs: { type: "number" },
                  domProps: { value: _vm.nestCutSetSec },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nestCutSetSec = $event.target.value
                    }
                  }
                }),
                _vm._v("秒/枚\n            "),
                _c("div", { staticClass: "comment" }, [
                  _vm._v("＊カット機にカット前の板をセットする時間")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", [_vm._v("板回転")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nestCutturnSec,
                      expression: "nestCutturnSec"
                    }
                  ],
                  attrs: { type: "number" },
                  domProps: { value: _vm.nestCutturnSec },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nestCutturnSec = $event.target.value
                    }
                  }
                }),
                _vm._v("秒/枚\n            "),
                _c("div", { staticClass: "comment" }, [
                  _vm._v("＊カット機で板を回転しセットする時間")
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestMode"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestZCutFlag"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestCutMinW"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestCutMinH"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestStackFlag"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestSawW"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestNigetsume"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestConfSpaceUp"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestConfSpaceLo"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestConfSpaceLt"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestConfSpaceRt"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestCutlengthSec"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestCutcutSec"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestCutSetSec"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["nestCutturnSec"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "button-area" }, [
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "button" },
              on: { click: _vm.onUpdate }
            },
            [_vm._v("設定")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "button" },
              on: { click: _vm.onCancel }
            },
            [_vm._v("キャンセル")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "title-area", attrs: { id: "modal-moving" } },
      [_c("h2", [_vm._v("ネスティング設定")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "sub-title" }, [
      _c("span", { staticClass: "label" }, [_vm._v("＜カット 条件設定＞")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "sub-title" }, [
      _c("span", { staticClass: "label" }, [_vm._v("＜カット機 条件設定＞")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_vm._v("後ろトリムY"), _c("br"), _vm._v("原板上余白")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_vm._v("後ろトリムX"), _c("br"), _vm._v("原板左余白")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_vm._v("前トリムX"), _c("br"), _vm._v("原板右余白")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_vm._v("前トリムY"), _c("br"), _vm._v("原板下余白")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92ba3496", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92ba3496","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/common/NestingConfigModal.vue
// module id = null
// module chunks = 